import { Colors, DefaultTheme } from 'react-native-paper';
import color from 'color';
import { merge } from 'lodash';

import { Theme } from './types';

const Light: Theme = merge(DefaultTheme, {
  dark: false,
  roundness: 16,
  containerRoundness: 16,
  colors: {
    primary: '#26b9b0',
    primaryDisabled: '#D96A00',
    secondary: '#0a50a1',
    additional: '#EdEdEd',
    accent: '#5cdb95',
    transparent: 'transparent',
    background: '#FFFFFF',
    surface: '#FBFBFB',
    error: '#D04E4E',
    success: '#26BAAC',
    text: '#4A4A4A',
    onPrimary: Colors.white,
    onSecondary: Colors.white,
    onAccent: '#403F3F',
    onBackground: '#757575',
    onSurface: '#4A4A4A',
    backPlus: '#F5FFFE',
    gold: '#FFD700',
    disabled: color(Colors.black).alpha(0.26).rgb().string(),
    placeholder: '#C4C4C4',
    backdrop: color(Colors.black).alpha(0.5).rgb().string(),
    shadow: '#ff00ff',
    notification: Colors.pinkA400,
  },
  typography: {
    heading: {
      1: {
        fontSize: 16,
        lineHeight: 24,
      },
      2: {
        fontSize: 14,
        lineHeight: 18,
      },
      3: {
        fontSize: 12,
        lineHeight: 18,
      },
    },
    body: {
      1: {
        fontSize: 14,
        lineHeight: 22,
      },
      2: {
        fontSize: 12,
        lineHeight: 18,
      },
      3: {
        fontSize: 14,
        lineHeight: 26,
      },
    },
    subtitle: {
      1: {
        fontSize: 14,
        lineHeight: 18,
      },
      2: {
        fontSize: 10,
        lineHeight: 18,
      },
    },
  },
});

export default Light;
